import React from "react"
import "./style.scss"

const Button = ({ children, className, ...props }) => {
  return (
    <button
      style={props.style}
      {...props}
      className={`custom-button ${className ? className : ""}`}
    >
      {children}
    </button>
  )
}

export default Button
